import * as React from 'react';

export const CinemaContext = React.createContext<any[]>([]);
